module.exports = __webpack_public_path__ + "static/media/slack.064c616e.png";